import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { FaCamera, FaTrash } from 'react-icons/fa';
import { updateEmployeeProfile } from '../http';
import { toast } from 'react-toastify';

const getInitials = (name = '') => {
  if (!name) return '';
  const names = name.trim().split(' ');
  if (names.length === 1) return names[0][0].toUpperCase();
  return (names[0][0] + names[names.length - 1][0]).toUpperCase();
};

const Profile = () => {
  const { user } = useSelector(state => state.authSlice);
  console.log(user);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(user?.image || '');
  const [profileName, setProfileName] = useState(user?.name || '');
  const [username] = useState(user?.username || '');
  const [dob, setDob] = useState(user?.dob ? user.dob.slice(0, 10) : '');
  const [email, setEmail] = useState(user?.email || '');
  const [status, setStatus] = useState(user?.status || '');
  const [showSave, setShowSave] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check if file size exceeds 500 KB (512000 bytes)
      if (file.size > 512000) {
        toast.error('Image size cannot exceed 500 KB');
        return;
      }
      
      setSelectedImage(file);
      setPreviewUrl(URL.createObjectURL(file));
      setShowSave(true);
    }
  };

  const handleChange = (setter) => (e) => {
    setter(e.target.value);
    setShowSave(true);
  };

  const handleSave = async (event) => {
    event.preventDefault();
    
    setIsLoading(true);
    
    try {
      const formData = new FormData();
      formData.append('profile', selectedImage);
      formData.append('id', user.id);
      formData.append('dob', dob);
    
      console.log(formData);
      const response = await updateEmployeeProfile(formData);
      if(response.status === 200){
        toast.success('Profile updated successfully');

        setShowSave(false);
        window.location.reload("/profile");
      } else {
        toast.error('Profile update failed');
      }
    } catch (error) {
      console.error('Error updating profile:', error);
      toast.error('An error occurred while updating profile');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh', background: '#f7f8fa' }}>
      <div className="card shadow" style={{ maxWidth: 900, width: '100%', borderRadius: 18, background: '#fff', padding: 0, border: 'none' }}>
        <div className="row no-gutters">
          {/* Left column: Profile summary */}
          <div className="col-md-4 d-flex flex-column align-items-center justify-content-center p-5 border-right" style={{ minHeight: 500 }}>
            <div style={{ position: 'relative', marginBottom: 24 }}>
              {previewUrl ? (
                <img
                  src={previewUrl}
                  alt="Profile"
                  name="profile"
                  className="rounded-circle bg-light"
                  style={{ width: 120, height: 120, objectFit: 'cover', border: '2px solid #e3eaef' }}
                />
              ) : (
                <div
                  className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white"
                  style={{ width: 120, height: 120, fontSize: 40, fontWeight: 700 }}
                >
                  {getInitials(profileName)}
                </div>
              )}
              <input
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                id="imageUpload"
                style={{ display: 'none' }}
              />
              <button
                className="btn btn-light btn-sm position-absolute"
                style={{ right: -10, bottom: -10, borderRadius: '50%', boxShadow: '0 2px 8px #eee', padding: 10 }}
                onClick={() => document.getElementById('imageUpload').click()}
                title="Change picture"
                disabled={isLoading}
              >
                <FaCamera size={18} />
              </button>
         
            </div>
            <div className="text-center w-100">
              <div style={{ fontWeight: 600, fontSize: 22 }}>{profileName}</div>
              <div className="text-muted mb-2" style={{ fontSize: 16 }}>@{username}</div>
              <div className="badge badge-light px-3 py-2 " style={{ fontSize: 14, fontWeight: 500,backgroundColor:'green',color:'white' }}>{status || 'No status'}</div>
            </div>
          </div>
          {/* Right column: Editable form */}
          <div className="col-md-8 p-5">
            <h3 className="mb-4" style={{ fontWeight: 700, fontSize: 24 }}>Edit Profile</h3>
            <form autoComplete="off">
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label className="small font-weight-bold mb-1">Full Name</label>
                  <input
                    type="text"
                    className="form-control  p-2"
                    style={{ boxShadow: 'none',borderRadius:'10px' }}
                    value={profileName}
                    onChange={handleChange(setProfileName)}
                    placeholder="Full Name"
                    disabled
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="small font-weight-bold mb-1">Date of Birth</label>
                  <input
                    type="date"
                    className="form-control  p-2"
                    style={{ background: 'transparent', boxShadow: 'none',borderRadius:'10px' }}
                    value={dob}
                    onChange={handleChange(setDob)}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group col-md-6">
                  <label className="small font-weight-bold mb-1">Email</label>
                  <input
                    type="email"
                    className="form-control  p-2"
                    style={{boxShadow: 'none',borderRadius:'10px' }}
                    value={email}
                    onChange={handleChange(setEmail)}
                    placeholder="Email"
                    disabled
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="small font-weight-bold mb-1">Username</label>
                  <div className="input-group">
              
                    <input
                      type="text"
                      className="form-control  p-2"
                      style={{  boxShadow: 'none' }}
                      value={username}
                      disabled
                    />
                  </div>
                </div>
              </div>
             
              <div className="pt-3 d-flex justify-content-center items-center">
                <button
                  className={`btn btn-primary btn-block rounded-pill py-2 ${showSave ? 'bg-grey-200' : 'bg-[#3B3FB6] '}`}
                  style={{ fontWeight: 600, fontSize: 17, letterSpacing: 1, opacity: showSave ? 1 : 0.5, maxWidth: 300,backgroundColor:'#3B3FB6' 
                  }}
                  disabled={!showSave || isLoading}
                  onClick={handleSave}
                >
                  {isLoading ? (
                    <div className="d-flex align-items-center justify-content-center">
                      <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                      <span>Updating...</span>
                    </div>
                  ) : 'Save Changes'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
